"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createProjectPagePath = exports.getDocumentsWithDataPath = exports.getStructuredDocumentLibraryItems = exports.searchStructuredDocumentsPath = exports.structuredAnalysisDocumentsPath = exports.createAnalysisPath = exports.viewBalanceSheetPath = exports.viewProfitAndLossPath = exports.viewDebtAndDebtLikePath = exports.viewNetWorkingCapitalPath = exports.viewQualityOfEarningsPath = exports.editAnalysisPath = exports.viewAnalysisPath = exports.addAnalysisFromTemplatePath = exports.addAnalysisTypePath = exports.analysesListPath = exports.editInsightPath = exports.createInsightPath = exports.viewInsightPath = exports.insightsListPath = exports.editHypothesisPath = exports.createHypothesisPath = exports.viewHypothesisPath = exports.hypothesesListPath = exports.buildUrl = exports.structuredRoutes = void 0;
const endSlash = new RegExp(/\/$/);
const startSlash = new RegExp(/^\//);

const assembleUrl = base => path => {
  const cleanBase = base.replace(endSlash, '');
  const cleanPath = path.replace(startSlash, '');
  return `${cleanBase}/${cleanPath}`;
};

const structuredRoutes = {
  QofE: 'quality-of-earnings',
  NWC: 'net-working-capital',
  PandL: 'profit-and-loss',
  DDL: 'debt-debt-like',
  BsV: 'balance-sheet'
};
exports.structuredRoutes = structuredRoutes;

const buildUrl = (base, path) => assembleUrl(base)(path);

exports.buildUrl = buildUrl;

const hypothesesListPath = projectId => `/projects/${projectId}/key-focus-areas/`;

exports.hypothesesListPath = hypothesesListPath;

const viewHypothesisPath = (projectId, hypothesisId) => `/projects/${projectId}/key-focus-areas/${hypothesisId}/view`;

exports.viewHypothesisPath = viewHypothesisPath;

const createHypothesisPath = projectId => `/projects/${projectId}/key-focus-areas/create`;

exports.createHypothesisPath = createHypothesisPath;

const editHypothesisPath = (projectId, hypothesisId) => `/projects/${projectId}/key-focus-areas/${hypothesisId}/edit`;

exports.editHypothesisPath = editHypothesisPath;

const insightsListPath = projectId => `/projects/${projectId}/insights`;

exports.insightsListPath = insightsListPath;

const viewInsightPath = (projectId, insightId) => `/projects/${projectId}/insights/${insightId}/view`;

exports.viewInsightPath = viewInsightPath;

const createInsightPath = projectId => `/projects/${projectId}/insights/create`;

exports.createInsightPath = createInsightPath;

const editInsightPath = (projectId, insightId) => `/projects/${projectId}/insights/${insightId}/edit`;

exports.editInsightPath = editInsightPath;

const analysesListPath = projectId => `/projects/${projectId}/analyses`;

exports.analysesListPath = analysesListPath;

const addAnalysisTypePath = projectId => `/projects/${projectId}/analyses/add-type`;

exports.addAnalysisTypePath = addAnalysisTypePath;

const addAnalysisFromTemplatePath = projectId => `/projects/${projectId}/analyses/add-from-template`;

exports.addAnalysisFromTemplatePath = addAnalysisFromTemplatePath;

const viewAnalysisPath = (projectId, analysisId) => `/projects/${projectId}/analyses/${analysisId}/view`;

exports.viewAnalysisPath = viewAnalysisPath;

const editAnalysisPath = (projectId, analysisId) => `/projects/${projectId}/analyses/${analysisId}/edit`;

exports.editAnalysisPath = editAnalysisPath;

const viewQualityOfEarningsPath = projectId => `/projects/${projectId}/analyses/quality-of-earnings`;

exports.viewQualityOfEarningsPath = viewQualityOfEarningsPath;

const viewNetWorkingCapitalPath = projectId => `/projects/${projectId}/analyses/net-working-capital`;

exports.viewNetWorkingCapitalPath = viewNetWorkingCapitalPath;

const viewDebtAndDebtLikePath = projectId => `/projects/${projectId}/analyses/debt-debt-like`;

exports.viewDebtAndDebtLikePath = viewDebtAndDebtLikePath;

const viewProfitAndLossPath = projectId => `/projects/${projectId}/analyses/profit-and-loss`;

exports.viewProfitAndLossPath = viewProfitAndLossPath;

const viewBalanceSheetPath = projectId => `/projects/${projectId}/analyses/balance-sheet`;

exports.viewBalanceSheetPath = viewBalanceSheetPath;

const createAnalysisPath = projectId => `/projects/${projectId}/analyses/create`;

exports.createAnalysisPath = createAnalysisPath;

const structuredAnalysisDocumentsPath = projectId => `/projects/${projectId}/StructuredAnalysisDocuments`;

exports.structuredAnalysisDocumentsPath = structuredAnalysisDocumentsPath;

const searchStructuredDocumentsPath = (projectId, documentCode, withData) => `/projects/${projectId}/StructuredAnalysisDocuments/search?documentCode=${documentCode}&withData=${withData}`;

exports.searchStructuredDocumentsPath = searchStructuredDocumentsPath;

const getStructuredDocumentLibraryItems = (projectId, documentId) => `/projects/${projectId}/StructuredAnalysisDocuments/${documentId}/LibraryItems`;

exports.getStructuredDocumentLibraryItems = getStructuredDocumentLibraryItems;

const getDocumentsWithDataPath = projectId => `/projects/${projectId}/StructuredAnalysisDocuments/withData`;

exports.getDocumentsWithDataPath = getDocumentsWithDataPath;
const createProjectPagePath = '/projects/create-project';
exports.createProjectPagePath = createProjectPagePath;